export var WORKSPACE_ID = {
    firstParty: 'office-365-apps',
    moreFromM365: 'more-m365-apps',
    moreFromMicrosoft: 'more-microsoft-365-apps',
    business: 'business-apps',
    customer: 'customer-workspace',
    allApps: 'allapps',
    mos: 'mos-apps',
    core: 'core-apps',
    aad: 'aad-apps',
    lob: 'lob-apps',
    featured: 'featured',
};
export var STORE_APP_ID = 'apps';
export var BANNER_ID = 'apps-module-banner';
export var MORE_MICROSOFT_APPS = [
    'Bing',
    'MSN',
    'Privacy',
    'Rewards',
];
export var COMMERCIAL_CORE_APPS_ID = [
    'ShellSkypeTeams',
    'ShellWordOnline',
    'ShellExcelOnline',
    'ShellPowerPointOnline',
    'ShellMail',
    'ShellDocuments',
    'ShellOneNoteOnline',
];
export var CONSUMER_CORE_APPS_ID = [
    'ShellWordOnline',
    'ShellExcelOnline',
    'ShellPowerPointOnline',
    'ShellDocuments',
    'ShellMail',
    'ShellTeams',
    'ShellClipchamp',
];
export var AppType;
(function (AppType) {
    AppType["Mos"] = "LaunchPage";
    AppType["FirstParty"] = "FirstParty";
    AppType["Dynamics"] = "Dynamics";
    AppType["AAD"] = "Graph";
    AppType["LOB"] = "LineOfBusiness";
    AppType["Unknown"] = "Unknown";
})(AppType || (AppType = {}));
export var SectionName;
(function (SectionName) {
    SectionName["Mos"] = "mos";
    SectionName["Core"] = "core";
    SectionName["Collection"] = "collection";
    SectionName["Category"] = "category";
    SectionName["AllApps"] = "allapps";
    SectionName["Featured"] = "featured";
})(SectionName || (SectionName = {}));
export var PageLevel;
(function (PageLevel) {
    PageLevel["L1"] = "L1";
    PageLevel["L2"] = "L2";
})(PageLevel || (PageLevel = {}));
export var Source;
(function (Source) {
    Source["contextMenu"] = "contextMenu";
    Source["dialogButton"] = "dialogButton";
    Source["dialogBody"] = "dialogBody";
    Source["directLink"] = "directLink";
})(Source || (Source = {}));
export var IconSize;
(function (IconSize) {
    IconSize["xsmall"] = "xsmall";
    IconSize["small"] = "small";
    IconSize["regular"] = "regular";
})(IconSize || (IconSize = {}));
//# sourceMappingURL=app-gallery.constants.js.map